import { render } from "./UserProjectsSelector.vue?vue&type=template&id=18eb1e80"
import script from "./UserProjectsSelector.vue?vue&type=script&lang=js"
export * from "./UserProjectsSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__